import { render, staticRenderFns } from "./Redirecting.vue?vue&type=template&id=adaa874c"
import script from "./Redirecting.vue?vue&type=script&lang=js"
export * from "./Redirecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports